import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import { AGENT_SITE, AGENT_SITE_COPPEL, PROFILES, STORAGE } from "../../constants";
import { AuthService } from "../../services/AuthService";
import { LocalStorageService } from "../../services/LocalStorageService";
import { useTranslation } from 'react-i18next';
import { ConfigurationService } from "../../services/ConfigurationService";
import SelectLanguage from "../../components/SelectLanguage";
import { UsersService } from "../../services/UsersService";
import { SupportService } from "../../services/SupportService";
import ThemeDropdown from "../../components/ThemeDropdown";

declare const HSCore: any;

function LoginPage() {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues: {
            user_name: '',
            password: ''
        },
    });

    const [errorMessage, seterrorMessage] = useState('')

    const getAccounts = async (id) => {
        const allData = {
            user_id: id
        }
        const { data } = await ConfigurationService.getAllAccounts(allData);
        LocalStorageService.save(STORAGE.ACCOUNTS_ASSIGNED, data)

        return data;
    }

    const getLinksSupport = async () => {
        const { data } = await SupportService.getAll();
        LocalStorageService.save(STORAGE.SUPPORT_DATA, data)

        return data;
    }

    const login = async (data) => {
        try {
            const response = await AuthService.login(data);

            if (response.data.versionPortal && response.data.versionPortal === 'v2') {
                LocalStorageService.save(STORAGE.SESSION_AGENT, true)

                if (response.data.cliente === 'coppel') {
                    window.location.href = AGENT_SITE_COPPEL + response.data.token;
                } else {
                    window.location.href = AGENT_SITE + response.data.token;
                }


                return;
            }

            // if(!response.data.id) {
            //     return alert('No cuenta con privilegios para esta operación')
            // }

            LocalStorageService.save(STORAGE.SESSION, response.data)
            LocalStorageService.save(STORAGE.TOKEN, response.data.token_api)


            await getLinksSupport();
            const accounts = await getAccounts(response.data.id);

            if(response.data.id === 5084) {
                await handlePermissions(response.data.id, accounts[0].account_id, response.data.profile)
                LocalStorageService.save(STORAGE.ACCOUNT_SELECTED, { ...accounts[0], id: accounts[0].account_id });
                navigate('/reports/licencias')
                return;
            }

            // const urlBotModule = () => {
            //     if(response.data.profile.toLowerCase() === PROFILES.ROOT ) {
            //         return  '/bot/accounts';
            //     }

            //     if(accounts.length === 1) {
            //         return `/bot/builder/${accounts[0].id}`
            //     }

            //     return  '/bot/accounts'; 
            // }

            if (accounts.length === 1) {
                await handlePermissions(response.data.id, accounts[0].account_id, response.data.profile)

                LocalStorageService.save(STORAGE.ACCOUNT_SELECTED, { ...accounts[0], id: accounts[0].account_id });
                navigate('/')
            } else {
                navigate('/select-account', { state: { accounts: accounts } })
            }


        } catch (error) {
            console.error('LoginPage.login.error::', error)
            seterrorMessage(error)
        }
    }

    const handlePermissions = async (user_id: number, account_id: number, profile: string) => {

        if (profile.toLowerCase() === PROFILES.ROOT || profile.toLowerCase() === PROFILES.ADMIN) {
            return LocalStorageService.save(STORAGE.PERMISSIONS, {
                full_access: true
            });
        }

        if (profile.toLowerCase() === PROFILES.SUPERVISOR) {

            const { data } = await UsersService.getCurrentPermissions({
                account_id,
                user_id
            })
            return LocalStorageService.save(STORAGE.PERMISSIONS, data);
        }

    }

    useEffect(() => {
        document.body.className = '';

        try {
            HSCore.components.HSTomSelect.init('.js-select')
        } catch (error) { }

        return () => {
            document.body.className = 'has-navbar-vertical-aside navbar-vertical-aside-show-xl footer-offset';
        };
    }, [])


    return (
        <div className="d-flex align-items-center min-h-100">
            <main id="content" role="main" className="main pt-0">

                <div className="container-fluid px-0">

                    <div className="row mx-0">

                        <div className="col-lg-6 d-flex justify-content-center align-items-center min-vh-lg-100 position-relative">

                            <div className="position-absolute top-0 start-0 end-0 d-lg-flex mt-3 mx-3">
                                <SelectLanguage />
                            </div>
                            <div className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1" style={{ maxWidth: '25rem' }} >

                                <form className="js-validate needs-validation" onSubmit={handleSubmit(login)}>
                                    <div className="text-center">
                                        <div className="d-grid">
                                            <img className="mb-5 logo-auth" src="/assets/img/logo.png" alt="Description" data-hs-theme-appearance="default" />
                                            <img className="mb-5 logo-auth" src="/assets/img/logo-dark.png" alt="Description" data-hs-theme-appearance="dark" />
                                        </div>

                                        <div className="mb-5">
                                            <h1 className="display-5 text-start">{t("auth.login.title")}</h1>
                                            <p className="text-start">{t("auth.login.text")}</p>
                                        </div>
                                    </div>



                                    {errorMessage && <div className="alert alert-soft-danger">{errorMessage}</div>}

                                    <div className="my-4">
                                        <Input label={t("auth.login.label-username")} errors={errors.user_name} {...register('user_name', { required: true })} />
                                    </div>

                                    <div className="mb-4">
                                        <Input label={t("auth.login.label-password")} type='password' errors={errors.password} {...register('password', { required: true })} />
                                    </div>


                                    <div className="d-grid mb-3">
                                        <Button type="submit" className="btn btn-primary btn-lg" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(login)}>{t("auth.login.label-btn")}</Button>
                                    </div>
                                    
                                    <div className="my-4 d-flex justify-content-end">
                                        {/* <label className="form-check-label d-grid">
                                            {t("auth.login.help")}
                                        </label>
                                        <a href="https://api.whatsapp.com/send?phone=5524156393&text=Hola, buen día, necesito de su apoyo" target="_blank" >
                                            <img className="mb-2 mt-1 logo-cw" src="/assets/img/whatsapp.png" alt="Description" /> Whatsapp
                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <a href="mailto:ayuda@voices.com.mx" >
                                            <img className="mb-2 mt-1 logo-cm" src="/assets/img/mail.png" alt="Description" />  {t("auth.login.mail")}
                                        </a> */}
                                        <ThemeDropdown />
                                    </div>
                                    {/* <div className="d-grid">
                                        <Link to='/auth/reset-password' className="btn btn-link text-decoration-underline fw-semibold">
                                            Recuperar contraseña
                                        </Link>
                                    </div> */}

                                </form>
                            </div>
                        </div>


                        <div
                            className="col-lg-6 d-none d-lg-flex justify-content-center align-items-center min-vh-lg-100 position-relative bg-light px-0"
                        // style={{
                        //     backgroundImage: 'url(/assets/img/auth-bg.png)',
                        //     backgroundRepeat: 'no-repeat',
                        //     backgroundSize: 'cover',
                        //     backgroundPosition: 'bottom'
                        // }}
                        >

                            <img src='/assets/img/bg-bot.png' className="img-fluid" />

                            {/* <div className="position-relative bg-gradient-primary h-100  px-7 border-radius-lg d-flex flex-column justify-content-center"
                                style={{
                                    backgroundImage: 'linear-gradient(310deg,#0b9238,#0a595f)'
                                }}
                            >
                                    <img src="https://demos.creative-tim.com/marketplace/soft-ui-dashboard-pro/assets/img/shapes/pattern-lines.svg" alt="pattern-lines" className="position-absolute opacity-4 start-0" />
                                    <div className="position-relative">
                                    <img className="max-width-500 w-100 position-relative z-index-2" src="https://demos.creative-tim.com/marketplace/soft-ui-dashboard-pro/assets/img/illustrations/chat.png" alt="chat-img" />
                                    </div>
                                    <h4 className="mt-5 text-white font-weight-bolder">"Attention is the new currency"</h4>
                                    <p className="text-white">The more effortless the writing looks, the more effort the writer actually put into the process.</p>
                            </div> */}

                        </div>



                    </div>
                </div>
            </main >
        </div >
    );
}

export default LoginPage;